export const externalCompaniesNaming = {
  EXTERNAL_WORKS_TO_ADD: 'external-works-to-add',
  EXTERNAL_WORKS_TO_DELETE: 'external-works-to-delete',
};
